import React from 'react';
import PropTypes from 'prop-types';
import {Box, Heading} from '@tenancy.nz/design-system';

function AccordionList({heading, items, renderItem, ...rest}) {
  return (
    <Box {...rest}>
      {heading && (
        <Box>
          <Heading as="h4">{heading}</Heading>
        </Box>
      )}
      <Box>{items.map(renderItem)}</Box>
    </Box>
  );
}

AccordionList.propTypes = {
  /**
   */
  heading: PropTypes.node,

  /**
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      details: PropTypes.node.isRequired,
      title: PropTypes.node.isRequired,
      markdown: PropTypes.bool,
    })
  ),

  /**
   */
  renderItem: PropTypes.func.isRequired,
};

AccordionList.defaultProps = {
  heading: undefined,
  items: [],
};

export default AccordionList;
